import { ChevronRight, MessageCircle, UsersRound } from 'lucide-react';
import { useTranslate } from 'ra-core';
import { Card } from '../../../components/ui/card';

type ChannelModalCardProps = {
  onClick: () => void;
  cardText: string;
  type: 'GROUP' | 'SUPERGROUP';
};

export const ChannelModalCard = (props: ChannelModalCardProps) => {
  const translate = useTranslate();

  const subtitleText =
    props.type === 'GROUP'
      ? translate('chat.groupCreateSubtitle')
      : translate('chat.supergroupCreateSubtitle');

  return (
    <Card className="rounded-md p-0 shadow-none">
      <button
        type="button"
        onClick={props.onClick}
        className="flex h-[90px] w-full items-center gap-3 p-4 text-left transition-colors hover:bg-muted"
      >
        {props.type === 'GROUP' ? (
          <MessageCircle className="size-8 shrink-0 text-primary" />
        ) : (
          <UsersRound className="size-8 shrink-0 text-primary" />
        )}
        <span className="mr-auto flex min-w-0 flex-col">
          <span className="ml-2 text-sm">{props.cardText}</span>
          <span className="ml-2 text-xs text-muted-foreground">
            {subtitleText}
          </span>
        </span>
        <ChevronRight className="size-5 shrink-0 text-muted-foreground" />
      </button>
    </Card>
  );
};
